import { of as observableOf, Observable, BehaviorSubject } from "rxjs";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { LocalStorageService } from "ngx-webstorage";
import { Router } from "@angular/router";
import { routes } from "environments/environment";
import { secret } from "app/app.env";
import { AppLoaderService } from "./app-loader/app-loader.service";
import { AppConfirmService } from "./app-confirm/app-confirm.service";
import { BodyEmail } from "../../smtp.env";

import { map, catchError } from "rxjs/operators";
import { Company } from "app/keys.env";

@Injectable()
export class PainelService {
  private refreshBehaviorSubject = new BehaviorSubject<string>(`nothing to do`);

  constructor(
    private http: HttpClient,
    private localStorage: LocalStorageService,
    private router: Router,
    private loader: AppLoaderService,
    private confirm: AppConfirmService
  ) {}

  refresh(valor: string) {
    this.refreshBehaviorSubject.next(valor);
  }

  isRefresh() {
    return this.refreshBehaviorSubject;
  }

  _header(): Observable<any> {
    const codeCobra = this.localStorage.retrieve(secret.userData).codeCobra;
    return (
      this.http
        // .get(`${routes.headers}?codecobra=${codeCobra}`)
        .get(`${routes.offices}?codecobra=${codeCobra}`)
        .pipe(map((res: any) => res.data))
    );
  }

  _registerEventAttendance(codeCobra): Observable<any> {
    const registerEventAttendanceOnInitialOperation =
      this.localStorage.retrieve(
        secret.parameters
      ).registerEventAttendanceOnInitialOperation;

    if (registerEventAttendanceOnInitialOperation != true) {
      return null;
    }

    return this.http
      .post(routes.event_attendance, {
        codeCobra: codeCobra,
        codeOperator: "ts-atende",
      })
      .pipe(
        map((res: any) => {
          try {
            return res;
          } catch (error) {
            console.log(error);
            throw error;
          }
        })
      );
  }

  _garantia(): Observable<any> {
    const codeCobra = this.localStorage.retrieve(secret.userData).codeCobra;
    return this.http
      .get(`${routes.garantias}?codecobra=${codeCobra}`)
      .pipe(map((res: any) => res.data));
  }

  _contracts(): Observable<any> {
    const codeCobra = this.localStorage.retrieve(secret.userData).codeCobra;
    return this.http
      .get(`${routes.contracts}?codecobra=${codeCobra}&codeoperator=ts-atende`)
      .pipe(
        map((res: any) =>
          res === null || res === undefined ? undefined : res.data
        )
      );
  }

  _office(): Observable<any> {
    const codeCobra = this.localStorage.retrieve(secret.userData).codeCobra;
    return this.http
      .get(
        `${routes.offices}?codecobra=${codeCobra}&verifygeneralparameter=yes`
      )
      .pipe(map((res: any) => res.data.office));
  }

  _agreements(): Observable<any> {
    const codeCobra = this.localStorage.retrieve(secret.userData).codeCobra;
    return (
      this.http
        .get(
          `${routes.agreements}?codecobra=${codeCobra}&returnwiththebestpayment=yes`
        )
        // .pipe(map((res: any) => res.data));
        .pipe(
          map((res: any) => {
            try {
              if (res.data) {
                return res.data;
              } else {
                throw res;
              }
            } catch (e) {
              throw res;
            }
          }),
          catchError((error) => {
            throw error.error.result;
            // console.log(error);
            // return Observable.throw(error.result);
          })
        )
    );
  }

  logout() {
    return this.http
      .patch(`${routes.logout}`, {
        token: this.localStorage.retrieve(secret.userData).token,
      })
      .pipe(map((res: any) => res.result));
  }

  validateToken(): Observable<any> {
    return this.http.post(
      `${routes.validate}`,
      this.localStorage.retrieve(secret.userData)
    );
  }

  _boleto(_schedulingId) {
    //console.log(_schedulingId);
    const codeCobra = this.localStorage.retrieve(secret.userData).codeCobra;
    console.log(
      `${routes.boleto}?codecobra=${codeCobra}&scheduleid=${_schedulingId}`
    );
    return this.http.get(
      `${routes.boleto}?codecobra=${codeCobra}&scheduleid=${_schedulingId}`
    );
  }

  smsService(data): Observable<any> {
    try {
      return this.http.post(`${routes.send_sms}`, data);
    } catch (e) {
      return observableOf("-->", e.message);
    }
  }

  _sendEmail(_data, email) {
    this.loader.open("Aguarde, obtendo informações do PDF.");

    let boleto = {
      return_type: "html",
      token: this.localStorage.retrieve(secret.userData).token,
      linhaDigitavel: _data.linhaDigitavel,
      linhaDigitavelSemFormatacao: _data.linhaDigitavelSemFormatacao,
      codBanco: _data.codBanco,
      agenciaCodigoBeneficiario: _data.agenciaCodigoBeneficiario,
      quantidade: _data.quantidade,
      carteiraNossoNumero: _data.carteiraNossoNumero,
      numeroDocumento: _data.numeroDocumento,
      cpfCnpj: _data.cpfCnpj,
      vencimento: _data.vencimento,
      valorDocumento: _data.valorDocumento,
      descontoAbatimento: _data.descontoAbatimento,
      outrasDeducoes: _data.outrasDeducoes,
      moraMulta: _data.moraMulta,
      outrosAcrescimos: _data.outrosAcrescimos,
      instrucoes: _data.instrucoes,
      instrucoesViaBanco: _data.instrucoesViaBanco,
      beneficiario: _data.beneficiario,
      credor: _data.credor,
      localPagamento: _data.localPagamento,
      dataDocumento: _data.dataDocumento,
      especieDoc: _data.especieDoc,
      especieMoeda: _data.especieMoeda,
      aceite: _data.aceite,
      dataProcessamento: _data.dataProcessamento,
      usoBanco: _data.usoBanco,
      carteira: _data.carteira,
      nomeDevedor: _data.nomeDevedor,
      enderecoDevedor: _data.enderecoDevedor,
      pagador: _data.pagador,
      pagadorViaCliente: _data.avalistaViaCliente,
      pagadorViaBanco: _data.avalistaViaBanco,
      emitenteViaCliente: _data.emitenteViaCliente,
      logoViaBanco: _data.logoViaBanco,
      logoViaCliente: _data.logoViaCliente,
      nomeLogoViaCliente: _data.nomeLogoViaCliente,
      nomeLogoViaBanco: _data.nomeLogoViaBanco,
      idRotinaAprovacao: _data.idRotinaAprovacao,
      barras: _data.barras,
    };
    //console.log("boletoToInvoice", boleto);
    return this.http.post(`${routes.invoice}`, boleto).subscribe(
      (res: any) => {
        //console.log("responseInvoice", res);
        this.loader.close();

        const { body } = res.data;

        let html = body;

        html = html.replace(/(\r\n\t|\n|\r\t)/gm, "");
        html = html.replace(/\s{2,}/g, " ");
        const { codeCobra, keyUserCompany, numberContract } =
          this.localStorage.retrieve(secret.userData);

        let detailsEmail = {
          to: email,
          digitableLine: boleto.linhaDigitavel,
          debtor: boleto.nomeDevedor,
          codeCobra: codeCobra,
          contractNumber: numberContract,
          nameOffice:
            Company[keyUserCompany].name || "Não listado no aplicativo atende",
        };

        this.toPdf(html, true, detailsEmail);
      },
      (err) => {
        this.loader.close();
        console.log(err);
      }
    );
  }

  _invoice(_data) {
    this.loader.open("Aguarde, obtendo informações do PDF.");
    let boleto = {
      return_type: "html",
      token: this.localStorage.retrieve(secret.userData).token,
      linhaDigitavel: _data.linhaDigitavel,
      linhaDigitavelSemFormatacao: _data.linhaDigitavelSemFormatacao,
      codBanco: _data.codBanco,
      agenciaCodigoBeneficiario: _data.agenciaCodigoBeneficiario,
      quantidade: _data.quantidade,
      carteiraNossoNumero: _data.carteiraNossoNumero,
      numeroDocumento: _data.numeroDocumento,
      cpfCnpj: _data.cpfCnpj,
      vencimento: _data.vencimento,
      valorDocumento: _data.valorDocumento,
      descontoAbatimento: _data.descontoAbatimento,
      outrasDeducoes: _data.outrasDeducoes,
      moraMulta: _data.moraMulta,
      outrosAcrescimos: _data.outrosAcrescimos,
      instrucoes: _data.instrucoes,
      instrucoesViaBanco: _data.instrucoesViaBanco,
      beneficiario: _data.beneficiario,
      credor: _data.credor,
      localPagamento: _data.localPagamento,
      dataDocumento: _data.dataDocumento,
      especieDoc: _data.especieDoc,
      especieMoeda: _data.especieMoeda,
      aceite: _data.aceite,
      dataProcessamento: _data.dataProcessamento,
      usoBanco: _data.usoBanco,
      carteira: _data.carteira,
      nomeDevedor: _data.nomeDevedor,
      enderecoDevedor: _data.enderecoDevedor,
      pagador: _data.pagador,
      pagadorViaCliente: _data.avalistaViaCliente,
      pagadorViaBanco: _data.avalistaViaBanco,
      emitenteViaCliente: _data.emitenteViaCliente,
      logoViaBanco: _data.logoViaBanco,
      logoViaCliente: _data.logoViaCliente,
      nomeLogoViaCliente: _data.nomeLogoViaCliente,
      nomeLogoViaBanco: _data.nomeLogoViaBanco,
      idRotinaAprovacao: _data.idRotinaAprovacao,
      barras: _data.barras,
    };
    //console.log("boletoToInvoice >>>>");
    //console.log(boleto);

    return this.http.post(`${routes.invoice}`, boleto).subscribe(
      (res: any) => {
        //console.log("responseInvoice", res);
        this.loader.close();
        const { body } = res.data;
        let html = body;
        html = html.replace(/(\r\n\t|\n|\r\t)/gm, "");
        html = html.replace(/\s{2,}/g, " ");
        this.toPdf(html);
      },
      (err) => {
        this.loader.close();
        console.log(err);
      }
    );
  }

  toPdf(_data, email?: boolean, emailDetails?) {
    //console.log("toPdf", _data);

    this.loader.open("Aguarde, gerando PDF.");

    //console.log(routes.toPdf, _data);
    return this.http
      .post(routes.toPdf, {
        html: _data,
        token: this.localStorage.retrieve(secret.userData).token,
      })
      .subscribe(
        (res: any) => {
          //console.log(res);
          const filename = res.data.name + ".pdf";
          if (!email) {
            var blob = new Blob([this.base64ToArrayBuffer(res.data.result)], {
              type: "application/pdf",
            });

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(blob, filename);
            } else {
              const a = document.createElement("a");
              document.body.appendChild(a);
              const url = window.URL.createObjectURL(blob);
              a.href = url;
              a.download = filename;
              a.click();
              setTimeout(() => {
                window.URL.revokeObjectURL(url);
                document.body.removeChild(a);
              }, 0);
            }

            //window.open(url);
            //console.log(window.navigator);
            //const linkSource = 'data:application/pdf;base64,' + ok.result;
            //const downloadLink = document.createElement('a');
            //downloadLink.href = linkSource;
            //downloadLink.download = filename;
            //downloadLink.click();
            this.loader.close();
          } else {
            this.loader.close();
            this.loader.open("Aguarde, enviando boleto por e-mail.");
            try {
              const {
                to,
                digitableLine,
                debtor,
                codeCobra,
                contractNumber,
                nameOffice,
              } = emailDetails;

              let body = BodyEmail(
                to,
                digitableLine,
                debtor,
                codeCobra,
                contractNumber,
                res.data.result,
                nameOffice
              );

              this.http
                .post(`${routes.send_email}`, body)
                .subscribe((res: any) => {
                  this.loader.close();
                  let data = {
                    title: "",
                    message: res.result.message,
                    login: false,
                  };
                  this.confirm.confirm(data);
                });
            } catch (error) {
              console.log(error);
              this.throwMistake(error, this.loader, this.confirm);
            }
          }
        },
        (err) => {
          console.log(err);
          this.throwMistake(err, this.loader, this.confirm);
        }
      );
  }

  chatParameters(codecobra) {
    return this.http
      .get(`${routes.chat_parameters}?codecobra=${codecobra}`)
      .pipe(map((res: any) => res.data));
  }

  base64ToArrayBuffer(base64) {
    const binary_string = window.atob(base64);
    const len = binary_string.length;
    const bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
  }

  downLoadFile(data: any) {
    var blob = new Blob([data], { type: "application/pdf" });
    var url = window.URL.createObjectURL(blob);
    window.open(url);
  }

  throwMistake(err, loader, confirm) {
    loader.close();
    let data = {
      title: "",
      message: err.error.result,
      login: false,
    };
    confirm.confirm(data);
  }

  clearLocalStorage() {
    this.localStorage.clear("contracts");
    this.localStorage.clear(secret.userData);
    const esc = this.localStorage.retrieve(secret.tsDebtor);
    //console.log(esc);
    let stringToNavigate =
      typeof esc === null ||
      typeof esc === undefined ||
      esc == null ||
      esc == undefined
        ? "/login"
        : "/login/" + esc;
    this.loader.open("Saindo...");

    // this.router.navigate(["/"]).then(() => this.loader.close());

    setTimeout(() => {
      this.loader.close();
      window.location.reload();
    }, 3000);
  }

  stringFromUTF8Array(data) {
    const extraByteMap = [1, 1, 1, 1, 2, 2, 3, 0];
    var count = data.length;
    var str = "";

    for (var index = 0; index < count; ) {
      var ch = data[index++];
      if (ch & 0x80) {
        var extra = extraByteMap[(ch >> 3) & 0x07];
        if (!(ch & 0x40) || !extra || index + extra > count) return null;

        ch = ch & (0x3f >> extra);
        for (; extra > 0; extra -= 1) {
          var chx = data[index++];
          if ((chx & 0xc0) != 0x80) return null;

          ch = (ch << 6) | (chx & 0x3f);
        }
      }

      str += String.fromCharCode(ch);
    }

    return str;
  }
}
